/* eslint-disable no-extend-native */
/* eslint-disable no-param-reassign */
import 'es6-promise/auto'
// import 'babel-polyfill'
import Vue from 'vue'
import vueSmoothScroll from 'vue-smooth-scroll'
import _ from 'lodash'
import VueCharts from 'vue-charts'
import VueLazyLoad from 'vue-lazyload'
import braze from '@/common/utils/braze'
import { getIp, getGuidIssue } from '@/common/utils/request'
import {
  getGUID,
  isDev,
  isPrerenderer,
  isQA,
  setGUID,
  setIp,
  setLibFile,
} from '@/common/utils/common'
import axios from 'axios'
import axiosCancel from 'axios-cancel'
// import infiniteScroll from 'vue-infinite-scroll'
import constant from '@/common/resources/constant'
import VueMeta from 'vue-meta'
import { datadogRum } from '@datadog/browser-rum'

// INFO: IE10 location.origin polyfill
if (!window.location.origin) {
  window.location.origin =
    window.location.protocol +
    '//' +
    window.location.hostname +
    (window.location.port ? ':' + window.location.port : '')
}

const Plugin = {
  install() {
    // TODO: redirection 처리
    axiosCancel(axios, { debug: true })
    Vue.prototype.$events = new Vue()
    Vue.prototype.$liveGnbEvents = new Vue()
    Vue.prototype.$previewEvents = new Vue()
    Vue.use(VueCharts)
    Vue.use(VueMeta, {
      keyName: 'metaInfo',
      attribute: 'data-vue-meta',
      ssrAttribute: 'data-vue-meta-server-rendered',
      tagIDKeyName: 'vmid',
      refreshOnceOnNavigation: true,
    })
    Vue.use(VueLazyLoad, {
      lazyComponent: true,
      preLoad: 1,
      attempt: 3,
      throttleWait: 200,
    })
    Vue.use(vueSmoothScroll)
    // Vue.use(infiniteScroll)
    getIp().then(({ data }) => {
      setIp(_.get(data, 'ip', ''))
    })

    if (getGUID() === '') {
      getGuidIssue().then(({ data }) => {
        setGUID(data)
      })
    }

    this.addPolyfill()

    this.initDataDogRum()

    if (isPrerenderer()) return

    // [sean:CTD-693] 광고 스크립트 추가
    let dc = document.getElementsByTagName('script')[0]
    if (!dc) {
      console.warn('no script tag')
      return
    }
    this.addGoogleAnalytics(dc)
    this.addNaverLog(dc)
    this.addFaceBookLog(dc)
    this.addAppsFlyerSDK()
    this.addTestAppsFlyerSDK()
    braze.initialize()
    // this.addAceCounter();
  },
  // checkBrowser () {
  //   window.browser = new UAParser().getBrowser()
  //   var agt = navigator.userAgent.toLowerCase()
  //   if (agt.indexOf('opera') !== -1) window.location.href = '/browser_update.html'
  //   if (agt.indexOf('staroffice') !== -1) window.location.href = '/browser_update.html'
  //   if (agt.indexOf('webtv') !== -1) window.location.href = '/browser_update.html'
  //   if (agt.indexOf('beonex') !== -1) window.location.href = '/browser_update.html'
  //   if (agt.indexOf('chimera') !== -1) window.location.href = '/browser_update.html'
  //   if (agt.indexOf('netpositive') !== -1) window.location.href = '/browser_update.html'
  //   if (agt.indexOf('phoenix') !== -1) window.location.href = '/browser_update.html'
  //   // if (agt.indexOf("firefox") != -1) return 'Firefox';
  //   // if (agt.indexOf("safari") != -1) return 'Safari';
  //   if (agt.indexOf('skipstone') !== -1) window.location.href = '/browser_update.html'
  //   if (agt.indexOf('netscape') !== -1) window.location.href = '/browser_update.html'
  //   // if (agt.indexOf('mozilla/5.0') !== -1) window.location.href = '/browser_update.html';
  //   if (agt.indexOf('msie') !== -1 || navigator.appVersion.indexOf('Trident/') > 0) {
  //     let rv = 0
  //     let ua = navigator.userAgent
  //     let re = new RegExp('MSIE ([0-9]{1,}[\\.0-9]{0,})')
  //     if (re.exec(ua) != null) rv = parseFloat(RegExp.$1)
  //     if (rv !== 0 && rv <= 9) {
  //       window.location.href = '/browser_update.html'
  //     }
  //   }
  // },
  addPolyfill() {
    if (!String.prototype.startsWith) {
      String.prototype.startsWith = function (searchString, position) {
        position = position || 0
        return this.substr(position, searchString.length) === searchString
      }
    }
  },
  addPooqPlayerLib(dc) {
    let asl = document.createElement('script')
    asl.async = false
    asl.src = constant.URL_PROTOCOL_WITH_DOMAIN + '/pooqplayer/lib/lib.js'
    dc.parentNode.insertBefore(asl, dc)
  },
  addPooqPlayerAdaptor(dc) {
    let asl = document.createElement('script')
    asl.async = false
    asl.src = constant.URL_PROTOCOL_WITH_DOMAIN + '/pooqplayer/playeradapt.js'
    dc.parentNode.insertBefore(asl, dc)
  },
  addGoogleAnalytics(dc) {
    let asl = document.createElement('script')
    asl.async = true
    asl.src = 'https://www.googletagmanager.com/gtag/js?id=UA-119955855-1'
    dc.parentNode.insertBefore(asl, dc)

    let asc = document.createElement('script')
    asc.text = `window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'UA-119955855-1');
      gtag('config', 'G-ZP2LB49VJ9');`
    dc.parentNode.insertBefore(asc, dc)

    // AdWords: 923131705
    let awl = document.createElement('script')
    awl.async = true
    awl.src = 'https://www.googletagmanager.com/gtag/js?id=AW-923131705'
    dc.parentNode.insertBefore(awl, dc)

    let awc = document.createElement('script')
    awc.text = `window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'AW-923131705');`
    dc.parentNode.insertBefore(awc, dc)
  },
  addNaverLog(dc) {
    let nsl = document.createElement('script')
    nsl.src = '//wcs.naver.net/wcslog.js'
    dc.parentNode.insertBefore(nsl, dc)

    let nsc = document.createElement('script')
    dc.parentNode.insertBefore(nsc, dc)
    nsl.onload = () => {
      nsc.text = `if (!wcs_add) var wcs_add={};
      wcs_add["wa"] = "s_26546d6bb182";
      if (!_nasa) var _nasa={};
      wcs.inflow("wavve.com");
      wcs_do(_nasa);`
    }
  },
  addFaceBookLog(dc) {
    let fsc = document.createElement('script')
    fsc.text = `!function(f,b,e,v,n,t,s){
      if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document, 'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '160912788027100');
      fbq('track', 'PageView');`
    dc.parentNode.insertBefore(fsc, dc)

    let fnc = document.createElement('noscript')
    let img = document.createElement('img')
    img.height = 1
    img.width = 1
    img.style.display = 'none'
    img.src =
      'https://www.facebook.com/tr?id=160912788027100&ev=PageView&noscript=1'
    fnc.appendChild(img)
    dc.parentNode.insertBefore(fnc, dc)

    let fpc = document.createElement('script')
    fpc.charset = 'UTF-8'
    fpc.src = '//t1.daumcdn.net/adfit/static/kp.js'
    dc.parentNode.insertBefore(fpc, dc)

    let fpv = document.createElement('script')
    dc.parentNode.insertBefore(fpv, dc)
    fpc.onload = () => {
      fpv.text = "kakaoPixel('5419070585473843165').pageView();"
    }
  },
  shareFacebook() {
    window.fbAsyncInit = function () {
      window.FB.init({
        appId: '1818575348440201',
        autoLogAppEvents: true,
        version: 'v4.0',
      })
    }
    setLibFile(
      document,
      'script',
      'facebook-jssdk',
      '//connect.facebook.net/ko_KR/sdk.js',
    )
  },
  addAppsFlyerSDK() {
    const dc = document.getElementsByTagName('script')[0]
    if (!dc) {
      console.warn('no script tag')
      return
    }
    const asl = document.createElement('script')
    asl.async = true
    asl.src = '/js/wavve.logger.js'
    dc.parentNode.insertBefore(asl, dc)
  },
  addTestAppsFlyerSDK() {
    const fsc = document.createElement('script')
    fsc.text =
      '!function(t,e,n,s,a,c,i,o,p){t.AppsFlyerSdkObject=a,t.AF=t.AF||function(){(t.AF.q=t.AF.q||[]).push([Date.now()].concat(Array.prototype.slice.call(arguments)))},t.AF.id=t.AF.id||i,t.AF.plugins={},o=e.createElement(n),p=e.getElementsByTagName(n)[0],o.async=1,o.src="https://websdk.appsflyer.com?"+(c.length>0?"st="+c.split(",").sort().join(",")+"&":"")+(i.length>0?"af_id="+i:""),p.parentNode.insertBefore(o,p)}(window,document,"script",0,"AF","pba",{pba: {webAppId: "fc4cdb2a-8701-4a8f-8e10-25157b5d2418", measurementStatus: true}})'
    document.body.appendChild(fsc)
  },
  initDataDogRum() {
    const env =
      isDev() || origin.indexOf('localhost') > -1
        ? 'dev'
        : isQA()
          ? 'qa'
          : 'prd'
    datadogRum.init({
      applicationId: 'b82cd837-1302-4376-b0e2-ce4ce1859b22',
      clientToken: 'pub052e41dff0f7df33217c59c115adafb1',
      // `site` refers to the Datadog site parameter of your organization
      // see https://docs.datadoghq.com/getting_started/site/
      site: 'datadoghq.com',
      service: 'wavve-pc-web',
      env: env,
      // Specify a version number to identify the deployed version of your application in Datadog
      // version: '1.0.0',
      sessionSampleRate: 10,
      sessionReplaySampleRate: 10,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: 'allow',
      allowedTracingUrls: [
        'https://apis.wavve.com',
        'https://account-api.wavve.com',
        'https://store-api.wavve.com',
        'https://partner.wavve.com',
      ],
    })
  },
}

export default Plugin
